export default __webpack_public_path__ + "static/media/IMG_9875.b7f9e610.jpg";